import { Zap, BatteryCharging, Combine } from "lucide-react";
import { Reveal, SectionHeading } from "./Motion";

const TYPES = [
  { id: "on-grid", icon: Zap, name: "On-Grid", tag: "Max Savings", best: "Regular power supply", line: "Bill drops to almost zero" },
  { id: "off-grid", icon: BatteryCharging, name: "Off-Grid", tag: "Battery Backup", best: "Frequent power cuts", line: "24x7 power without the grid" },
  { id: "hybrid", icon: Combine, name: "Hybrid", tag: "Savings + Backup", best: "Savings and backup both", line: "Grid + battery, smart switching" },
];

export const SolarTypes = () => (
  <section id="types" data-testid="solar-types-section" className="section-pad relative">
    <div className="container-x">
      <SectionHeading eyebrow="Solar Types" title="Choose Your Solar System" />
      <div className="mt-14 grid gap-6 md:grid-cols-3">
        {TYPES.map((t, i) => (
          <Reveal key={t.id} delay={i * 0.12}>
            <div data-testid={`solar-type-card-${t.id}`} className="glass card-lift group relative h-full overflow-hidden rounded-3xl p-7 sm:p-8">
              <span className="absolute -right-2 -top-6 font-display text-[120px] font-extrabold text-navy-900/[0.05]">0{i + 1}</span>
              <div className="grid h-16 w-16 place-items-center rounded-2xl bg-gold/10 ring-1 ring-gold/30 transition-colors duration-300 group-hover:bg-gold">
                <t.icon className="h-8 w-8 text-gold-ink transition-colors duration-300 group-hover:text-navy-950" />
              </div>
              <div className="mt-6 flex flex-wrap items-center gap-3">
                <h3 className="font-display text-3xl font-bold text-navy-900">{t.name}</h3>
                <span className="rounded-full bg-gold/15 px-3 py-1 text-sm font-semibold text-gold-ink">{t.tag}</span>
              </div>
              <p className="mt-4 text-lg text-slate-700">
                <span className="text-slate-500">Best for: </span>
                {t.best}
              </p>
              <p className="mt-1 text-lg text-slate-600">{t.line}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
